// API Service Layer for MAnime Admin
// This simulates real API calls with localStorage for persistence

class ApiService {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
    this.initializeData();
  }

  // Initialize default data in localStorage if not exists
  initializeData() {
    const defaultData = {
      movies: [],
      categories: [
        { id: 1, name: 'Action', slug: 'action', description: 'Phim hành động', status: 'active', createdAt: new Date().toISOString() },
        { id: 2, name: 'Romance', slug: 'romance', description: 'Phim lãng mạn', status: 'active', createdAt: new Date().toISOString() },
        { id: 3, name: 'Comedy', slug: 'comedy', description: 'Phim hài', status: 'active', createdAt: new Date().toISOString() },
        { id: 4, name: 'Drama', slug: 'drama', description: 'Phim chính kịch', status: 'active', createdAt: new Date().toISOString() },
        { id: 5, name: 'Fantasy', slug: 'fantasy', description: 'Phim giả tưởng', status: 'active', createdAt: new Date().toISOString() }
      ],
      statuses: [
        { id: 1, name: 'Ongoing', slug: 'ongoing', description: 'Đang phát sóng', color: '#4CAF50', createdAt: new Date().toISOString() },
        { id: 2, name: 'Complete', slug: 'complete', description: 'Đã hoàn thành', color: '#2196F3', createdAt: new Date().toISOString() },
        { id: 3, name: 'Drop', slug: 'drop', description: 'Tạm dừng', color: '#F44336', createdAt: new Date().toISOString() },
        { id: 4, name: 'Coming Soon', slug: 'coming-soon', description: 'Sắp ra mắt', color: '#FF9800', createdAt: new Date().toISOString() }
      ],
      groups: [
        { id: 1, name: 'Anime Vietsub', slug: 'anime-vietsub', description: 'Nhóm dịch chính thức', website: 'https://animevietsub.tv', status: 'active', createdAt: new Date().toISOString() },
        { id: 2, name: 'AnimeHay', slug: 'animehay', description: 'Nhóm dịch phụ', website: 'https://animehay.tv', status: 'active', createdAt: new Date().toISOString() },
        { id: 3, name: 'HHPViet', slug: 'hhpviet', description: 'Hoạt hình Phương Tây Việt', website: 'https://hhpviet.tv', status: 'active', createdAt: new Date().toISOString() }
      ],
      servers: [
        { id: 1, name: 'VIP Server', type: 'vip', url: 'https://vip.server.com', status: 'active', priority: 1, description: 'Server VIP chất lượng cao', createdAt: new Date().toISOString() },
        { id: 2, name: 'HD Server', type: 'hd', url: 'https://hd.server.com', status: 'active', priority: 2, description: 'Server HD chất lượng tốt', createdAt: new Date().toISOString() },
        { id: 3, name: 'FB Server', type: 'fb', url: 'https://fb.server.com', status: 'active', priority: 3, description: 'Server FB dự phòng', createdAt: new Date().toISOString() }
      ],
      members: [
        { id: 1, username: 'admin', email: 'admin@manime.com', role: 'admin', name: 'Administrator', status: 'active', lastLogin: new Date().toISOString(), createdAt: new Date().toISOString() },
        { id: 2, username: 'moderator', email: 'mod@manime.com', role: 'moderator', name: 'Moderator', status: 'active', lastLogin: new Date(Date.now() - 86400000).toISOString(), createdAt: new Date().toISOString() },
        { id: 3, username: 'editor', email: 'editor@manime.com', role: 'editor', name: 'Content Editor', status: 'active', lastLogin: new Date(Date.now() - 172800000).toISOString(), createdAt: new Date().toISOString() }
      ],
      covers: [
        { id: 1, name: 'Anime Cover 1', url: 'https://img.phimapi.com/upload/vod/20241201-1/0a4c3b8f1b4e1bde7d1c6f7a5d45bfa1.jpg', type: 'movie', movieId: null, size: '1920x1080', format: 'jpg', createdAt: new Date().toISOString() },
        { id: 2, name: 'Anime Cover 2', url: 'https://img.phimapi.com/upload/vod/20241130-1/f8e4b9c2d6e1a8d4c5b2a9f7e3d1c8b5.jpg', type: 'movie', movieId: null, size: '1920x1080', format: 'jpg', createdAt: new Date().toISOString() }
      ],
      reports: [
        { id: 1, movieId: 1, title: 'Video không tải được', description: 'Tập 5 không thể phát', type: 'video', status: 'pending', reportedBy: 'user123', createdAt: new Date(Date.now() - 86400000).toISOString() },
        { id: 2, movieId: 2, title: 'Phụ đề sai', description: 'Phụ đề không đồng bộ với video', type: 'subtitle', status: 'resolved', reportedBy: 'user456', createdAt: new Date(Date.now() - 172800000).toISOString() }
      ],
      notifications: [
        { id: 1, title: 'Cập nhật hệ thống', message: 'Hệ thống sẽ bảo trì vào 2h sáng', type: 'system', status: 'active', sendTo: 'all', scheduledAt: null, createdAt: new Date().toISOString() }
      ],
      settings: {
        siteName: 'MAnime',
        siteDescription: 'Trang web xem anime miễn phí',
        siteKeywords: 'anime, hoạt hình, vietsub',
        siteUrl: 'https://manime.tv',
        adminEmail: 'admin@manime.com',
        maintenanceMode: false,
        registrationEnabled: true,
        commentsEnabled: true,
        socialSharing: true,
        analyticsId: '',
        seoEnabled: true
      }
    };

    // Initialize each data type if not exists
    Object.keys(defaultData).forEach(key => {
      if (!localStorage.getItem(`manime_${key}`)) {
        localStorage.setItem(`manime_${key}`, JSON.stringify(defaultData[key]));
      }
    });
  }

  // Generic HTTP methods
  async get(endpoint) {
    try {
      // Simulate API call with localStorage
      const data = JSON.parse(localStorage.getItem(`manime_${endpoint}`) || '[]');
      return { success: true, data };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async post(endpoint, data) {
    try {
      const existingData = JSON.parse(localStorage.getItem(`manime_${endpoint}`) || '[]');
      const newItem = {
        ...data,
        id: Date.now(), // Simple ID generation
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      existingData.push(newItem);
      localStorage.setItem(`manime_${endpoint}`, JSON.stringify(existingData));
      return { success: true, data: newItem };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async put(endpoint, id, data) {
    try {
      const existingData = JSON.parse(localStorage.getItem(`manime_${endpoint}`) || '[]');
      const index = existingData.findIndex(item => item.id === parseInt(id));
      if (index === -1) {
        return { success: false, error: 'Item not found' };
      }
      existingData[index] = {
        ...existingData[index],
        ...data,
        updatedAt: new Date().toISOString()
      };
      localStorage.setItem(`manime_${endpoint}`, JSON.stringify(existingData));
      return { success: true, data: existingData[index] };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async delete(endpoint, id) {
    try {
      const existingData = JSON.parse(localStorage.getItem(`manime_${endpoint}`) || '[]');
      const filteredData = existingData.filter(item => item.id !== parseInt(id));
      localStorage.setItem(`manime_${endpoint}`, JSON.stringify(filteredData));
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  // Categories API
  async getCategories() {
    return this.get('categories');
  }

  async createCategory(data) {
    const slug = data.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    return this.post('categories', { ...data, slug });
  }

  async updateCategory(id, data) {
    if (data.name) {
      data.slug = data.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    }
    return this.put('categories', id, data);
  }

  async deleteCategory(id) {
    return this.delete('categories', id);
  }

  // Status API
  async getStatuses() {
    return this.get('statuses');
  }

  async createStatus(data) {
    const slug = data.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    return this.post('statuses', { ...data, slug });
  }

  async updateStatus(id, data) {
    if (data.name) {
      data.slug = data.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    }
    return this.put('statuses', id, data);
  }

  async deleteStatus(id) {
    return this.delete('statuses', id);
  }

  // Groups API
  async getGroups() {
    return this.get('groups');
  }

  async createGroup(data) {
    const slug = data.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    return this.post('groups', { ...data, slug });
  }

  async updateGroup(id, data) {
    if (data.name) {
      data.slug = data.name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    }
    return this.put('groups', id, data);
  }

  async deleteGroup(id) {
    return this.delete('groups', id);
  }

  // Servers API
  async getServers() {
    return this.get('servers');
  }

  async createServer(data) {
    return this.post('servers', data);
  }

  async updateServer(id, data) {
    return this.put('servers', id, data);
  }

  async deleteServer(id) {
    return this.delete('servers', id);
  }

  // Members API
  async getMembers() {
    return this.get('members');
  }

  async createMember(data) {
    return this.post('members', data);
  }

  async updateMember(id, data) {
    return this.put('members', id, data);
  }

  async deleteMember(id) {
    return this.delete('members', id);
  }

  // Covers API
  async getCovers() {
    return this.get('covers');
  }

  async createCover(data) {
    return this.post('covers', data);
  }

  async updateCover(id, data) {
    return this.put('covers', id, data);
  }

  async deleteCover(id) {
    return this.delete('covers', id);
  }

  async uploadCover(file) {
    // Simulate file upload
    return new Promise((resolve) => {
      setTimeout(() => {
        const mockUrl = `https://img.manime.com/covers/${Date.now()}_${file.name}`;
        resolve({
          success: true,
          data: {
            url: mockUrl,
            name: file.name,
            size: file.size,
            type: file.type
          }
        });
      }, 1000);
    });
  }

  // Reports API
  async getReports() {
    return this.get('reports');
  }

  async createReport(data) {
    return this.post('reports', data);
  }

  async updateReport(id, data) {
    return this.put('reports', id, data);
  }

  async deleteReport(id) {
    return this.delete('reports', id);
  }

  // Notifications API
  async getNotifications() {
    return this.get('notifications');
  }

  async createNotification(data) {
    return this.post('notifications', data);
  }

  async updateNotification(id, data) {
    return this.put('notifications', id, data);
  }

  async deleteNotification(id) {
    return this.delete('notifications', id);
  }

  async sendNotification(id) {
    // Simulate sending notification
    const result = await this.put('notifications', id, { status: 'sent', sentAt: new Date().toISOString() });
    return result;
  }

  // Settings API
  async getSettings() {
    const data = JSON.parse(localStorage.getItem('manime_settings') || '{}');
    return { success: true, data };
  }

  async updateSettings(data) {
    try {
      const existingSettings = JSON.parse(localStorage.getItem('manime_settings') || '{}');
      const updatedSettings = { ...existingSettings, ...data, updatedAt: new Date().toISOString() };
      localStorage.setItem('manime_settings', JSON.stringify(updatedSettings));
      return { success: true, data: updatedSettings };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  // Movies API (with external API integration)
  async getMovies() {
    try {
      // First try to get from localStorage
      const localMovies = JSON.parse(localStorage.getItem('manime_movies') || '[]');
      
      // If we have movies and they're recent (less than 1 hour old), use cached data
      const cacheTime = localStorage.getItem('manime_movies_cache_time');
      const oneHourAgo = Date.now() - (60 * 60 * 1000);
      
      if (localMovies.length > 0 && cacheTime && parseInt(cacheTime) > oneHourAgo) {
        return { success: true, data: localMovies };
      }
      
      // Fetch from multiple pages to get more movies
      console.log('Fetching fresh movie data from API...');
      const promises = [];
      const maxPages = 3; // Fetch first 3 pages for performance
      
      for (let page = 1; page <= maxPages; page++) {
        promises.push(
          fetch(`https://phimapi.com/v1/api/danh-sach/hoat-hinh?page=${page}&country=nhat-ban`)
            .then(res => res.json())
        );
      }
      
      const responses = await Promise.all(promises);
      let allMovies = [];
      
      responses.forEach((apiData, pageIndex) => {
        if (apiData.status === 'success' && apiData.data?.items) {
          const pageMovies = apiData.data.items.map((item, itemIndex) => {
            // Parse episodes - better logic
            const totalEpisodes = parseInt(item.episode_total) || 0;
            let currentEpisodes = totalEpisodes; // Default to completed
            
            // Try to parse current from episode_current
            if (item.episode_current) {
              const match = item.episode_current.match(/\d+/);
              if (match) {
                currentEpisodes = parseInt(match[0]);
              }
            }
            
            // Ensure current never exceeds total
            if (currentEpisodes > totalEpisodes && totalEpisodes > 0) {
              currentEpisodes = totalEpisodes;
            }
            
            return {
              id: item._id || `${item.slug}-${pageIndex}-${itemIndex}`,
              name: item.name,
              slug: item.slug,
              originName: item.origin_name,
              content: item.content || 'Chưa có mô tả',
              type: item.type,
              status: currentEpisodes === totalEpisodes && totalEpisodes > 0 ? 'completed' : 'ongoing',
              posterUrl: item.poster_url,
              thumbUrl: item.thumb_url,
              isCopyright: item.is_copyright,
              subDocquyen: item.sub_docquyen,
              chieuRap: item.chieurap,
              trailerUrl: item.trailer_url,
              time: item.time,
              episodeCurrent: item.episode_current,
              episodeTotal: item.episode_total,
              episodes: currentEpisodes,
              episode_total: totalEpisodes,
              quality: item.quality,
              lang: item.lang,
              notify: item.notify,
              showtimes: item.showtimes,
              year: item.year,
              view: item.view || Math.floor(Math.random() * 5000000) + 100000,
              actor: item.actor || [],
              director: item.director || [],
              category: item.category || [],
              country: item.country || [],
              createdAt: item.created?.time || new Date().toISOString(),
              updatedAt: item.modified?.time || new Date().toISOString(),
              // Admin specific fields
              isPublic: true,
              isHot: false,
              adminNotes: ''
            };
          });
          allMovies = [...allMovies, ...pageMovies];
        }
      });
      
      // Remove duplicates by slug
      const uniqueMovies = allMovies.filter((movie, index, self) => 
        index === self.findIndex(m => m.slug === movie.slug)
      );
      
      console.log(`Fetched ${uniqueMovies.length} unique movies from ${maxPages} pages`);
      
      // Cache the results
      localStorage.setItem('manime_movies', JSON.stringify(uniqueMovies));
      localStorage.setItem('manime_movies_cache_time', Date.now().toString());
      
      return { success: true, data: uniqueMovies };
    } catch (error) {
      console.error('Error fetching movies:', error);
      // Fallback to cached data if API fails
      const fallbackMovies = JSON.parse(localStorage.getItem('manime_movies') || '[]');
      return { success: true, data: fallbackMovies };
    }
  }

  async updateMovie(id, data) {
    try {
      const movies = JSON.parse(localStorage.getItem('manime_movies') || '[]');
      const index = movies.findIndex(movie => movie.id === id || movie._id === id);
      
      if (index === -1) {
        return { success: false, error: 'Movie not found' };
      }
      
      movies[index] = {
        ...movies[index],
        ...data,
        updatedAt: new Date().toISOString()
      };
      
      localStorage.setItem('manime_movies', JSON.stringify(movies));
      return { success: true, data: movies[index] };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  // Leech API
  async searchMovies(query, source = 'phimapi') {
    try {
      const response = await fetch(`https://phimapi.com/v1/api/tim-kiem?keyword=${encodeURIComponent(query)}&limit=20`);
      const data = await response.json();
      
      if (data.status === 'success') {
        return { success: true, data: data.data?.items || [] };
      }
      
      return { success: false, error: 'Search failed' };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async leechMovie(movieData) {
    try {
      // Simulate leeching process
      const leechedMovie = {
        ...movieData,
        id: Date.now(),
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString(),
        isPublic: true,
        isHot: false,
        adminNotes: `Leeched from external source at ${new Date().toLocaleString()}`
      };
      
      const movies = JSON.parse(localStorage.getItem('manime_movies') || '[]');
      movies.push(leechedMovie);
      localStorage.setItem('manime_movies', JSON.stringify(movies));
      
      return { success: true, data: leechedMovie };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }
}

// Create singleton instance
const apiService = new ApiService();
export default apiService;